<template>
  <transition name="slideup">
    <div v-if="active" class="modal">
      <div class="modal-content">
        <div v-if="heading" class="modal-heading margins-off">
          <h2>{{ heading }}</h2>
          <div class="modal-headingcontrols">
            <slot name="heading-controls"></slot>
          </div>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
      </div>
      <div class="modal-controls controls">
        <button class="control" @click="$emit('close')">
          <icon-x>Close</icon-x>
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import IconX from "@/components/icons/IconX";

export default {
  components: {
    IconX
  },
  props: {
    active: Boolean,
    heading: String
  }
};
</script>

<style lang="scss">
.modal {
  // backdrop-filter: saturate(180%) blur(20px);
  // background-color: rgba(black, 0.7);
  background-color: $color-purple;
  margin: 0;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.modal-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.modal-heading {
  align-items: baseline;
  background-color: $color-purple;
  display: flex;
  justify-content: space-between;
  padding: 1.25rem;
  position: sticky;
  top: 0;
  z-index: 100;

  h2 {
    line-height: 1.2;
  }
}

.modal-body {
  padding: 0 1.25rem 6rem;
}

.modal-controls {
  background-image: linear-gradient(
    rgba($color-purple, 0),
    rgba($color-purple, 1)
  );
  padding: 1.25rem 1.25rem 1.5rem;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}

// Firefox specific
// @-moz-document url-prefix() {
//   .modal {
//     background-color: rgba(black, 0.9);
//   }
// }
</style>
